export function OrganizationSchema() {
  const data = {
    "@context": "https://schema.org", "@type": ["Organization", "InsuranceAgency"],
    name: "Trio Insurance & Financial Services",
    alternateName: "CompareWorkersComp.com",
    url: "https://compareworkerscomp.com",
    description: "Licensed California insurance agency helping business owners compare workers compensation insurance from 50+ carriers",
    telephone: "+1-415-928-2886",
    email: "info@trioins.com",
    areaServed: { "@type": "State", name: "California" },
    address: {
      "@type": "PostalAddress",
      addressRegion: "CA",
      addressCountry: "US"
    },
    sameAs: ["https://trioinsureme.com", "https://dentalworkerscomp.com"],
    hasCredential: {
      "@type": "EducationalOccupationalCredential",
      credentialCategory: "Insurance License",
      recognizedBy: { "@type": "GovernmentOrganization", name: "California Department of Insurance" },
      identifier: "0C66738"
    }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function WebSiteSchema() {
  const data = {
    "@context": "https://schema.org", "@type": "WebSite",
    name: "CompareWorkersComp.com", url: "https://compareworkerscomp.com",
    description: "Compare workers compensation insurance quotes from 50+ carriers for California businesses"
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function ServiceSchema({ name, description, areaServed }) {
  const data = {
    "@context": "https://schema.org", "@type": "Service",
    name, description, provider: { "@type": "Organization", name: "CompareWorkersComp.com" },
    areaServed: { "@type": "Place", name: areaServed || "California" },
    serviceType: "Workers Compensation Insurance Comparison"
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function FAQSchema({ faqs }) {
  if (!faqs || !faqs.length) return null;
  const data = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faqs.map(f => ({
      "@type": "Question", name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a }
    }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function HowToSchema() {
  const data = {
    "@context": "https://schema.org", "@type": "HowTo",
    name: "How to Compare Workers Comp Insurance in California",
    step: [
      { "@type": "HowToStep", name: "Tell us your industry", text: "Select your business industry from our list of categories" },
      { "@type": "HowToStep", name: "Get matched with agents", text: "We match you with licensed California insurance agents" },
      { "@type": "HowToStep", name: "Compare quotes", text: "Review and compare competitive quotes from 50+ carriers" },
      { "@type": "HowToStep", name: "Get covered", text: "Choose the best coverage for your business and get insured" }
    ]
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function SpeakableSchema({ name, url, cssSelector = '.speakable-intro' }) {
  const data = {
    "@context": "https://schema.org", "@type": "WebPage", name, url,
    speakable: { "@type": "SpeakableSpecification", cssSelector: [cssSelector, 'h1'] }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function BreadcrumbSchema({ items }) {
  const data = {
    "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem", position: i + 1,
      name: item.name,
      item: item.url ? `https://compareworkerscomp.com${item.url}` : undefined
    }))
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function ArticleSchema({ title, description, slug, datePublished, dateModified }) {
  const data = {
    "@context": "https://schema.org", "@type": "Article",
    headline: title, description,
    url: `https://compareworkerscomp.com/blog/${slug}`,
    datePublished, dateModified: dateModified || datePublished,
    author: { "@type": "Organization", name: "CompareWorkersComp.com" },
    publisher: { "@type": "Organization", name: "CompareWorkersComp.com" },
    speakable: { "@type": "SpeakableSpecification", cssSelector: ['.speakable-intro', 'h1'] }
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}
